module.exports = __webpack_public_path__ + "static/media/Glucerna.61dc6a4a.png";